export default __webpack_public_path__ + "static/media/CustomerRealCase1.210dd7c1.jpg";